<template>
  <div>       
    <div class='dataContainer' >
        <ul class="list-group">
            <li class="list-group-item list-group-item-warning" v-show='gotData' >
                <div>
                    <span class='IndexWidth'      >#</span>                    
                    <span class='CarBrandWidth'   >Marca</span>
                    <span class='ModelBrandWidth' >Modelo:&nbsp;&nbsp;<input v-model='filteredName' style='width:110px;'>&nbsp;&nbsp;<span class='glyphicon glyphicon-search glyphiconSize' ></span></span>                    
                    <span class='PriorityWidth'   >Prioridad</span>
                    <span class='ActiveWidth'     >Activo</span>
                    <span class='btnWidth'        >Borrar</span>
                    <span class='btnWidth'        >Guardar</span>
                </div>
            </li>
            <li class="list-group-item" v-show='gotData' >  
                <div>          
                    <span  class='IndexWidth' ></span>
                    <select class="form-control CarBrandWidth"  v-model='newItem.carbrand_id' >                                                          
                        <option v-for="carBrandDetail in carBrandDetails" v-bind:value='carBrandDetail.id' :selected='carBrandDetail.id == 0'  > {{carBrandDetail.name}} </option>
                    </select>
                    <span> <input class='ModelBrandWidth'   type='text'     v-model='newItem.name'></span>                    
                    <span> <input class='PriorityWidth'     type='text'     v-model='newItem.priority'></span>                
                    <span  class='ActiveWidth'><input       type="checkbox" v-model="newItem.active"></span>                    
                    <span  class='btnWidth' ></span>
                    <span  class='btnWidth' ><button        type="button"   class="btn btn-success glyphicon glyphicon-plus-sign glyphiconSize" @click='addRow(newItem)' ></button></span>
                </div>
            </li>        
            <li class="list-group-item" v-for='(detailsObj, index) in filteredDetails' v-if='index < 10' >  
                <div>          
                    <span  class='IndexWidth' >{{ index+1 }}</span>                                                            
                    <select class="form-control CarBrandWidth"  v-model='detailsObj.carbrand_id' >                                                          
                        <option v-for="carBrandDetail in carBrandDetails" v-bind:value='carBrandDetail.id' :selected='carBrandDetail.id == detailsObj.carbrand_id'  > {{carBrandDetail.name}} </option>
                    </select>
                    <span> <input class='ModelBrandWidth' type='text'     v-model='detailsObj.name'></span>
                    <span> <input class='PriorityWidth'   type='text'     v-model='detailsObj.priority'></span>                
                    <span  class='ActiveWidth'><input     type="checkbox" v-model="detailsObj.active"></span>
                    <span  class='btnWidth' ><button      type="button"   class="btn btn-danger glyphicon glyphicon glyphicon-remove glyphiconSize" @click='deleteRow(detailsObj)' ></button></span>
                    <span  class='btnWidth' ><button      type="button"   class="btn btn-success glyphicon glyphicon-ok glyphiconSize"    @click='updateRow(detailsObj)' ></button></span>
                </div>
            </li>        
        </ul>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../../main';

export default {  
  data: function () {     
    return {
        newItem: {
            carbrand_id:0,
            name:'',
            priority: 99,
            active: true,
            deleted: 0
        },
        itemDetails: [],
        filteredName: '',
        gotData: false,        
        carBrandDetails: []
    }
  }, 
  mounted: function () {        
        this.getItemsDetails();
        this.getCarBrandDetails();
  },
  methods: {
    getItemsDetails: function() {             
        this.$http.get('api/carmodels/details/maxresult/200').then(response => {                        
            this.itemDetails = response.body;
            this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },   
    updateRow: function({id,name,carbrand_id,priority,active})
    {                
        active = active ? 1 : 0;        
        this.$http.put('api/carmodels/' + id, {name, carbrand_id, priority, active, deleted:0} ).then(response => {                                    
            eventBus.$emit('resultMessage',response);   
            this.getItemsDetails();                                
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },
    deleteRow: function({id})
    {                        
        this.$http.delete('api/carmodels/' + id).then(response => {                                    
          eventBus.$emit('resultMessage',response);                         
          this.getItemsDetails();          
        }, response => {
            eventBus.$emit('errorMsg',response);
        });
    },
    addRow: function({carbrand_id,name,priority,active,deleted}){

        active = active ? 1 : 0;        
        this.$http.post('api/carmodels/', {carbrand_id, name, priority, active, deleted} ).then(response => {                        
          eventBus.$emit('resultMessage',response);                             
          this.getItemsDetails();     
          this.clearNewField();     
        }, response => {            
            eventBus.$emit('errorMsg',response);       
        });
    },   
    getCarBrandDetails: function() {             
        this.$http.get('api/carbrands/details/maxresult/200').then(response => {                        
            this.carBrandDetails = response.body;
            this.carBrandDetails.unshift({id:0,name:'Selecionar',"priority": 1,"active": 1})
            //this.gotData = true;                     
        }, response => {            
            eventBus.$emit('errorMsg',response);
        });
    },   
    clearNewField: function  (){
         this.newItem.carbrand_id = 0;
         this.newItem.name        = '';
         this.newItem.priority    = 99;
         this.newItem.active      = true;
         this.newItem.deleted     = 0;        
    }
  },
  filters: {
     
  },
  computed: {
    filteredDetails: function() {        
        return this.itemDetails.filter((element) => {                        
            return element.name.toLowerCase().match(this.filteredName.toLowerCase());
        });
    }      
  }
}
</script>

<style scoped>
   .dataContainer{
       width:780px;
       margin-left: 50px;
   }

   .IndexWidth {
        display:inline-block;
        width:30px;
        padding-left: 10px;
   }
   .CarBrandWidth {
        display:inline-block;
        width:180px;        
   }

   .ModelBrandWidth {
        display:inline-block;
        width:220px;
        margin-left: 20px;
   }

   .PriorityWidth {
        display:inline-block;
        width:50px;
        margin-left: 20px;
        text-align: right;
   }

   .ActiveWidth {
        display:inline-block;
        width:50px;
        margin-left: 20px;
        text-align: center;
   }

   .btnWidth{
        width:50px;
        margin-left: 10px;  
        display:inline-block;      
   }   

   .glyphiconSize{
       font-size: 1.4em;
   }
</style>



// WEBPACK FOOTER //
// CarModelAdmin.vue?5a5bd438